import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Signin from "./screens/Signin";
import Carousel from "./screens/Carousel";
import ChooseHosp from "./screens/ChooseHosp";
import ChooseView from "./screens/ChooseView";
import ColumnView from "./screens/ColumnView";
import ColumnCarousel from "./screens/ColumnCarousel";
import ChooseDoctors from "./screens/ChooseDoctors";
import ChooseDoctor from "./screens/ChooseDoctor";
import ChooseCarouselDoctors from "./screens/ChooseCarouselDoctors";
import QrSignin from "./screens/QrSignin";
import Settings from "./screens/Settings";
import ProfileSelection from "./screens/ProfileSelection";
import ProfilePreview from "./screens/ProfilePreview";
import QueueV2Profiles from "./v2/screens/QueueV2Profiles";
import QueueV2Setup from "./v2/screens/QueueV2Setup";
import QueueV2Display from "./v2/screens/QueueV2Display";

const AppRoutes: React.FC = () => {
  const [toggleState, setToggleState] = useState<boolean>(() => {
    return localStorage.getItem("adsToggle") === "true";
  });

  // ✅ Ensure toggle state syncs across refresh
  useEffect(() => {
    const savedState = localStorage.getItem("adsToggle") === "true";
    setToggleState(savedState);
  }, []);

  return (
    <Routes>
      <Route path="/qrsignin/:session_id" element={<QrSignin />}></Route>
      <Route path="/" element={<Signin />} />
      <Route path="/admin" element={<ChooseHosp />} />
      <Route path="/:hospital_id/profiles" element={<ProfileSelection />} />
      <Route
        path="/:hospital_id/profiles/:profileId"
        element={<ProfilePreview />}
      />

      <Route
        path="/:hospital_id"
        element={<ChooseView setToggleStates={setToggleState} />}
      />
      <Route path="/:hospital_id/choose-doctors" element={<ChooseDoctors />} />

      <Route 
        path="/:hospital_id/choose-carousel-doctors" 
        element={<ChooseCarouselDoctors />} 
      />
      <Route
        path="/:hospital_id/carousel-view"
        element={<Carousel isToggled={toggleState} />}
      />
      {/* After login a TV picks a dashboard-configured profile. /v2/setup is
          the manual escape hatch for a hospital with no profiles yet. */}
      <Route path="/:hospital_id/v2" element={<QueueV2Profiles />} />
      <Route path="/:hospital_id/v2/setup" element={<QueueV2Setup />} />
      <Route path="/:hospital_id/v2/display" element={<QueueV2Display />} />
      <Route path="/:hospital_id/column-view" element={<ColumnView />} />
      <Route path="/:hospital_id/column-carousel-view" element={<ColumnCarousel />} />
      <Route path="/:hospital_id/choose-doctor" element={<ChooseDoctor />} />
      <Route path="/:hospital_id/settings" element={<Settings />} />
      {/* <Route path="/:hospital_id/clinic-and-Scan-view" element={<ClinicAndScanView/>} /> */}
      {/* <Route path="/:hospital_id/scan-view" element={<ScanView/>} /> */}
    </Routes>
  );
};

export default AppRoutes;
